// 学习接口
export default function (axios) {
  return {
    // 学员-列表
    xx_searchApi(params) {
      return axios.post("/study/search", params);
    },

    // /study/removeClassFromStudy
    removeClassFromStudy(data) {
      return axios.post("/study/removeClassFromStudy", data);
    }
  };
}
